import React from 'react'
import styled from 'styled-components'
import Img from 'gatsby-image'
import minecraftLegacyAnimation from '../images/mcLegacy.gif'

const StyledMinecraftLegacyAnimation = styled.div`
  width: 500px;
  margin-right: 160px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-top: 20px;
  @media (max-width: 768px) {
    width: 300px;
    margin-right: 0;
  }
`

const FrameImage = styled.div`
  position: absolute;
  top: -7%;
  width: 134%;
  z-index: 0;
`

const Gif = styled.img`
  z-index: 1;
`

class MinecraftLegacyAnimation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      hoverIndex: 1,
    }
  }

  handleHover(index) {
    this.setState({ hoverIndex: index })
  }

  render() {
    return (
      <StyledMinecraftLegacyAnimation>
        <FrameImage>
          <Img
            fluid={this.props.data.minecraftLegacyFrame.childImageSharp.fluid}
          />
        </FrameImage>
        <Gif src={minecraftLegacyAnimation} alt="minecraft legacy timeline" />
      </StyledMinecraftLegacyAnimation>
    )
  }
}

export default MinecraftLegacyAnimation
